// src/components/AddOdbiorca.js
import React, { useState, useContext, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { useMediaQuery } from "react-responsive";
import { baseURL } from "../../utils/api";

const AddOdbiorca = ({ onAddSuccess }) => {
  const toast = useRef(null);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const { user, token } = useContext(AuthContext);
  const [nazwa, setNazwa] = useState("");
  const [adres, setAdres] = useState("");
  const [nip, setNip] = useState("");
  const [email, setEmail] = useState("");
  const [odbiorcy, setOdbiorcy] = useState([]);
  const [editingOdbiorca, setEditingOdbiorca] = useState(null);
  // Jeśli false – pokaż tylko dostępnych, true – pokaż wszystkie
  const [showAll, setShowAll] = useState(false);

  // Dodawanie nowego odbiorcy – rekord nowo dodawany ma domyślnie dostepny: true
  const handleSubmit = () => {
    const newOdbiorca = { nazwa, adres, nip, email, dostepny: true };
    // sprawdź czy nip już istnieje (dla wszystkich rekordów, niezależnie od dostępności)
    if (odbiorcy.some((odbiorca) => odbiorca.nip === nip)) {
      alert("Odbiorca o podanym NIP już istnieje");
    } else {
      axios
        .post(`${baseURL}api/kontrahenciAdd`, newOdbiorca, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          console.log("Dodano odbiorcę:", response.data);
          setNazwa("");
          setAdres("");
          setNip("");
          setEmail("");
          setOdbiorcy([...odbiorcy, response.data]);
          onAddSuccess();
        })
        .catch((error) => {
          console.error("Błąd dodawania odbiorcy:", error);
        });
    }
  };

  useEffect(() => {
    axios
      .get(`${baseURL}api/kontrahenci`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => setOdbiorcy(response.data))
      .catch((error) => console.error("Błąd pobierania odbiorców:", error));
  }, [token]);

  // Zamiast usuwania, zmieniamy status dostępności
  // const handleToggleAvailability = (odbiorca) => {
  //   const updatedOdbiorca = { ...odbiorca, dostepny: !odbiorca.dostepny }
  //   axios
  //     .put(`${baseURL}api/kontrahenci/${odbiorca.id}`, updatedOdbiorca, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     })
  //     .then((response) => {
  //       console.log("Zaktualizowano odbiorcę:", response.data)
  //       setOdbiorcy(
  //         odbiorcy.map((o) => (o.id === odbiorca.id ? response.data : o))
  //       )
  //     })
  //     .catch((error) => {
  //       console.error("Błąd aktualizacji dostępności odbiorcy:", error)
  //     })
  // }

  // Rozpoczęcie edycji wiersza
  const handleEditClick = (odbiorca) => {
    setEditingOdbiorca({ ...odbiorca });
  };

  // Zapis zmian edytowanego wiersza
  const handleSaveClick = () => {
    axios
      .put(`${baseURL}api/kontrahenci/${editingOdbiorca.id}`, editingOdbiorca, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        console.log("Zaktualizowano odbiorcę:", response.data);
        setOdbiorcy(
          odbiorcy.map((o) => (o.id === editingOdbiorca.id ? response.data : o))
        );
        setEditingOdbiorca(null);
        toast.current.show({
          severity: "success",
          summary: "Sukces",
          detail: "Odbiorca zaktualizowany",
          life: 3000,
        });
        // Jeśli aktualizujemy dostępność, wywołaj funkcję zewnętrzną
      })
      .catch((error) => {
        console.error("Błąd aktualizacji odbiorcy:", error);
      });
  };

  // Anulowanie edycji
  const handleCancelClick = () => {
    setEditingOdbiorca(null);
    toast.current.show({
      severity: "info",
      summary: "Anulowano",
      detail: "Anulowano edycję odbiorcy",
      life: 3000,
    });
  };

  // Renderowanie komórek edytowalnych lub zwykłych
  const textBodyTemplate = (rowData, field) => {
    if (editingOdbiorca && editingOdbiorca.id === rowData.id) {
      return (
        <InputText
          value={editingOdbiorca[field]}
          onChange={(e) =>
            setEditingOdbiorca({ ...editingOdbiorca, [field]: e.target.value })
          }
        />
      );
    }
    return rowData[field];
  };

  // Dla pola NIP używamy InputMask, gdy edytujemy
  const nipBodyTemplate = (rowData) => {
    if (editingOdbiorca && editingOdbiorca.id === rowData.id) {
      return (
        <InputMask
          value={editingOdbiorca.nip}
          onChange={(e) =>
            setEditingOdbiorca({ ...editingOdbiorca, nip: e.target.value })
          }
          mask="999-999-99-99"
        />
      );
    }
    return rowData.nip;
  };

  // Kolumna z przyciskami edycji oraz możliwością zmiany dostępności poprzez Checkbox
  const actionBodyTemplate = (rowData) => {
    if (editingOdbiorca && editingOdbiorca.id === rowData.id) {
      return (
        <React.Fragment>
          <Button
            icon="pi pi-save"
            className="p-button-success p-mr-2"
            onClick={handleSaveClick}
          />
          <Button
            icon="pi pi-times"
            className="p-button-secondary"
            onClick={handleCancelClick}
          />
        </React.Fragment>
      );
    } else {
      return (
        <Button
          // label="Edytuj"
          icon="pi pi-pencil"
          className="p-button-text p-button-sm"
          onClick={() => handleEditClick(rowData)}
        // className="p-button-warning"
        />
      );
    }
  };

  const handleToggleAvailability = (material) => {
    if (editingOdbiorca) {
      setEditingOdbiorca({
        ...editingOdbiorca,
        dostepny: !editingOdbiorca.dostepny,
      });
    }
  };

  // Kolumna "Dostępny" – checkbox edytowalny tylko w trybie edycji, poza edycją wyświetlamy jako disabled
  const availabilityBodyTemplate = (rowData) => {
    if (editingOdbiorca && editingOdbiorca.id === rowData.id) {
      return (
        <Checkbox
          checked={editingOdbiorca.dostepny}
          onChange={() => handleToggleAvailability(rowData)}
        />
      );
    } else {
      return <Checkbox checked={rowData.dostepny} disabled />;
    }
  };

  return (
    <div>
      <Toast ref={toast} />
      <div className="add-form">
        <h3>Dodaj nowego odbiorcę</h3>
        <div className="add-input">
          <label>Nazwa:</label>
          <InputText value={nazwa} onChange={(e) => setNazwa(e.target.value)} />
        </div>
        <div className="add-input">
          <label>Adres:</label>
          <InputText value={adres} onChange={(e) => setAdres(e.target.value)} />
        </div>
        <div className="add-input">
          <label>Email:</label>
          <InputText value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="add-input">
          <label>NIP:</label>
          <InputMask
            value={nip}
            onChange={(e) => setNip(e.target.value)}
            mask="999-999-99-99"
          />
        </div>
        <Button
          label="Dodaj odbiorcę"
          onClick={handleSubmit}
          disabled={!nazwa || !adres || !nip}
        />
      </div>

      <Button
        label={showAll ? "Pokaż tylko dostępnych" : "Pokaż wszystkie"}
        onClick={() => setShowAll(!showAll)}
        style={{ margin: "1rem 0" }}
      />
      {isMobile && (
        <div style={{ textAlign: "center", marginTop: "1rem" }}>
          <i>
            W celu uzyskania lepszej widoczności danych, skorzystaj z orientacji
            poziomej
          </i>
        </div>
      )}
      <DataTable
        value={showAll ? odbiorcy : odbiorcy.filter((o) => o.dostepny)}
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 15]}
        selectionMode="single"
        style={{ marginTop: "30px" }}
      >
        <Column
          header="Nazwa"
          field="nazwa"
          sortable
          body={(rowData) => textBodyTemplate(rowData, "nazwa")}
        />
        <Column
          header="Adres"
          field="adres"
          sortable
          body={(rowData) => textBodyTemplate(rowData, "adres")}
        />
        <Column
          header="Email"
          field="email"
          sortable
          body={(rowData) => textBodyTemplate(rowData, "email")}
        />
        <Column header="NIP" field="nip" sortable body={nipBodyTemplate} />
        <Column
          header="Dostępny"
          field="dostepny"
          sortable
          body={availabilityBodyTemplate}
          headerStyle={{ textAlign: "center", width: "7rem" }}
          bodyStyle={{ textAlign: "center" }}
        />
        {user?.role === "Administrator" && (
          <Column header="Akcje" body={actionBodyTemplate} />
        )}
      </DataTable>
    </div>
  );
};

export default AddOdbiorca;
